import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    nombre: 'ALIO POS vuex',
    UserCardId: '',
    PosId: localStorage.getItem('posId'),
    items: [],
    customer: [],
    custShipToList: [],
    authContactList: [],
    curOrder: '',    
    focussearch: false,
    paymMethods: [],
    globaldiscpct: 0,
    globaldiscamount: 0,
    printdoc: '',
    isPrintable: false,
    printButtonText: 'Imprimir',
    curDocType: 1,
    orderPrePayments: [],
    orderproperties: {
      CombineShipments: 0,
      SalesPerson: { id: '', name: '' },
      ExtDocNo: '',
      ShipToCode: '',
      AuthContact: '',
      custName2: '',
      custAddr: '',
      custPostCode: '',
      custCity: '',
      custVATNo: ''
    },
    itemproperties: {
      itemno: '',
      description: '',
      length: 0,
      height: 0,
      width: 0,
      qty: 0
    },
    paymentDocType: 0,
    activeModal : false,
    modalMsg : "",
    vale: 0,
    voucherModal: 0
  },  
  mutations: {
    setUser (state, CardId) {
      state.UserCardId = CardId
    },
    setPosId (state, PosId) {
      state.PosId = PosId
    },
    setSalesPerson(state, Id) {
      state.orderproperties.SalesPerson = Id
    },
    SetExtDocNo(state, value) {
      state.orderproperties.ExtDocNo = value
    },
    SetShipToCode(state, value) {
      state.orderproperties.ShipToCode = value
    },
    SetAuthContact(state, value) {
      state.orderproperties.AuthContact = value
    },
    setitemproperties (state, itemprops) {
      state.itemproperties.itemno = itemprops.itemno
      state.itemproperties.description = itemprops.description      
      state.itemproperties.length = itemprops.length
      state.itemproperties.height = itemprops.height
      state.itemproperties.width = itemprops.width
      state.itemproperties.qty = itemprops.qty
    },
    clearitemproperties (state) {
      state.itemproperties.itemno = ''
      state.itemproperties.description = ''
      state.itemproperties.length = 1
      state.itemproperties.height = 1
      state.itemproperties.width = 1
      state.itemproperties.qty = 1
    },
    setOrderproperties (state, orderprops) {
      console.log(orderprops)
      state.orderproperties.custName2 = orderprops.custName2
      state.orderproperties.custAddr = orderprops.custAddr
      state.orderproperties.custPostCode = orderprops.custPostCode
      state.orderproperties.custCity = orderprops.custCity
      state.orderproperties.custVATNo = orderprops.custVATNo
    },
    clearOrderproperties (state) {
      state.orderproperties.custName2 = ''
      state.orderproperties.custAddr = ''
      state.orderproperties.custPostCode = ''
      state.orderproperties.custCity = ''
      state.orderproperties.custVATNo = ''
    },
    addItem (state, item) {
      state.items.push(item)
    },
    delItem (state, index) {
      state.items.splice(index, 1)
    },
    resetCart (state) {
      state.items = []
      state.globaldiscamount = 0
      state.globaldiscpct = 0
      state.printdoc = ''
      state.isPrintable = false
      state.printButtonText = 'Imprimir'
    },
    updItem (state, { index, data }) {
      //el servicio web de nav devuelve los importes con separador de miles (.) y separador decimal (,)
      Vue.set(state.items[index], 'unitprice', data.unitprice.replace(/\,/g,''))
      Vue.set(state.items[index], 'linedisc', data.linedisc.replace(/\,/g,''))
      Vue.set(state.items[index], 'lineamount', data.lineamount.replace(/\,/g,''))
      Vue.set(state.items[index], 'vat', data.vat.replace(/\,/g,''))
      Vue.set(state.items[index], 'linetotal', data.linetotal.replace(/\,/g,''))
      Vue.set(state.items[index], 'availqty', data.availqty.replace(/\,/g,''))      
      Vue.set(state.items[index], 'location', data.location)
    },
    setCust (state, Cust) {
      state.customer = Cust
    },
    setcustShipToList (state, list) {
      state.custShipToList = list
    },
    setAuthContactList (state, list) {
      state.authContactList = list
    },
    setcurOrder (state, OrderNo) {
      state.curOrder = OrderNo
    },
    setcurDocType (state, DocType) {
      state.curDocType = DocType
    },
    setpaymentDocType (state, paymentDocType) {
      state.paymentDocType = paymentDocType
    },
    updateCombineShipments (state, val) {
      state.orderproperties.CombineShipments = val
    },
    setFocusSearch(state, val) {
      state.focussearch = val
    },
    addPaymMethod (state, pm) {
      function findFirstLargeNumber(element) {
        return element.paymenttype == pm.paymenttype && 
               element.paymdate == pm.paymdate && 
               element.anticipo == pm.anticipo && 
               element.new == pm.new &&
               element.voucherNo == pm.voucherNo
      }
      let exists = state.paymMethods.findIndex(findFirstLargeNumber)
      if (exists > -1)
        if ((pm.voucherNo != null) && (pm.voucherNo != '')){
          //no hacer nada, no duplicar vale
        } else {
          state.paymMethods[exists].amount += parseFloat(pm.amount)
        }
      else
        state.paymMethods.push(pm)
    },
    addCashMov (state, pm) {
      state.paymMethods.push(pm)
    },
    setPaymMethod (state, pm) {
      state.paymMethods = JSON.parse(JSON.stringify(pm))
    },
    clearPaymMethod (state) {
      state.paymMethods = []
    },
    setglobaldiscpct(state, val) {
      state.globaldiscpct = val
    },
    setglobaldiscamount(state, val) {
      state.globaldiscamount = val
    },
    setprintdoc(state, val) {
      state.printdoc = val
    },
    setorderPrePayments(state, val) {
      state.orderPrePayments = val
    },
    setIsPrintable(state, val) {
      state.isPrintable = val
    },
    setPrintButtonText(state, val) {
      state.printButtonText = val
    },
    setModalVisible(state, val) {
      state.activeModal = val      
    },
    setModalMsg(state, val) {
      state.modalMsg = val
    },
    updateProp: (state, payload) => {
      const { prop, value } = payload
      Vue.set(state.orderproperties, prop, value)
    },
    setVale (state, value) {
      state.vale = value
    },
    setVoucherModal (state, value) {
      state.voucherModal = value
    },
  },
  actions: {
    resetPOS(store) {
      store.commit('resetCart')
      store.commit('setUser', '')
      store.commit('setcurOrder', '')
      store.commit('SetExtDocNo', '')
      store.commit('clearOrderproperties')      
      store.commit('setorderPrePayments', [])
      store.commit('SetShipToCode', '')
      store.commit('setcustShipToList', [])
      store.commit('setAuthContactList', [])
      store.commit('SetAuthContact', '')
      store.commit('setcurDocType', 1)
      store.commit('setIsPrintable', false)
      store.commit('setPrintButtonText', 'Imprimir')
      axios.post(Vue.prototype.ApiBaseUrl + 'CustSearch/GetDefaultCust',
        JSON.stringify(store.state.PosId),
        { headers: {"Content-Type": "application/json"} })
        .then((response) => {
          store.commit('setCust', response.data[0])                
          store.commit('updateCombineShipments', store.state.customer.combineShip)                
        })
    },
    resetPOSRecover(store) {
      store.commit('resetCart')
    },
    setCustomer(store,customer) {
      store.commit('setCust', customer)
    }
  },
  getters: {
    OrderTotal: state => {
      let sum = 0
      state.items.forEach(item => {
        sum += parseFloat(item.lineamount)
      })
      return sum
    },
    OrderTotalVAT: state => {
      let sum = 0
        state.items.forEach(item => {
          sum += parseFloat(item.linetotal) - parseFloat(item.lineamount)
        })
        return sum + state.globaldiscamount
    },
    OrderTotalIncVAT: state => {
      let sum = 0
        state.items.forEach(item => {
          sum += parseFloat(item.linetotal)
        })
        return sum
    },
    OrderTotalPaym: state => {
      let sum = 0
      state.paymMethods.forEach(paymMethod => {
        sum += parseFloat(paymMethod.amount)
      })
      return parseFloat(sum).toFixed(2)
    },
    OrderLines: state => {
      let sum = 0
        state.items.forEach(item => {
          sum += 1
        })
        return sum
    },
    NewPaymMovs:  state => {
      return state.paymMethods.filter(item => item.new == true)          
    },
    IsPrintable: state => {
      return state.isPrintable
    },
    PrintButtonText: state => {
      return state.printButtonText
    }
  },
  //Variables que se guardan de manera permantente incluso si se actualiza la página
  plugins: [
    createPersistedState({
      key: 'AlioPosData',
      paths: [
        'items','UserCardId','customer','isPrintable',
        'printButtonText','custShipToList','authContactList',
        'curOrder','curDocType','globaldiscpct',
        'globaldiscamount','printdoc','orderproperties',
        'orderPrePayments'
      ]
  })]
})